import React from 'react';
import SocialOrganization from "./SocialOrganization";
import PersonalMembers from "./PersonalMembers";
import UnitMembers from "./UnitMembers";
import Researchers from "./Researchers";
import Employees from "./Employees";

const DataCount = () => {
    return (
        <>
            <SocialOrganization/>
            <PersonalMembers/>
            <UnitMembers/>
            <Researchers/>
            <Employees/>
        </>
    )
};

export default DataCount;
